import { ListingEntreprisesComponent } from './zone-activite/listing/listing.component';
import { FormService } from './locaux/services/form.service';
import { ApiLocauxService } from './locaux/services/api-locaux.service';
import { ApiAnnuaireService } from './annuaire/services/api-annuaire.service';
import { RouterModule } from '@angular/router';

import { NgModule } from '@angular/core';

import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import {HashLocationStrategy, Location, LocationStrategy} from '@angular/common';

import { AppComponent } from './app.component';
import { FormComponent } from './annuaire/form/form.component';
import { ListingComponent } from './annuaire/listing/listing.component';
import { SingleComponent } from './annuaire/single/single.component';
import { AppRoutingModule } from './/app-routing.module';
import { HttpModule } from '@angular/http';
import { FormLocauxComponent } from './locaux/form-locaux/form-locaux.component';
import { ListingLocauxComponent } from './locaux/listing-locaux/listing-locaux.component';
import { SingleLocalComponent } from './locaux/single-local/single-local.component';
import { PaginationComponent } from './pagination/pagination.component';

import { ExcerptFilter } from './excerpt.filter';
import { LightboxModule } from 'angular2-lightbox';
import { LocalByZaComponent } from './locaux/filter/local-by-za.component';



@NgModule({
  declarations: [
    AppComponent,
    FormComponent,
    ListingComponent,
    SingleComponent,
    FormLocauxComponent,
    ListingLocauxComponent,
    SingleLocalComponent,
    PaginationComponent,
    ExcerptFilter,
    ListingEntreprisesComponent,
    LocalByZaComponent
  ],
  imports: [
    RouterModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    HttpModule,
    LightboxModule
  ],
  providers: [
    {provide: LocationStrategy, useClass: HashLocationStrategy},
    ApiAnnuaireService,
    ApiLocauxService,
    FormService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts